import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast"; // Import Toaster and toast
import "./CertificateVerification.css";

const CertificateVerification = () => {
  const [certificateId, setCertificateId] = useState("");
  const [error, setError] = useState("");
  const [verificationData, setVerificationData] = useState(null);
  const [loading, setLoading] = useState(false); 

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true); 
      try {
        // Simulating an API call
        const response = await fetch(`https://gdgoc-szabist-website.onrender.com/api/certificates/verify/${certificateId}`); 
        const result = await response.json();

        if (result.status === "valid") {
          console.log(result);
          console.log("works")
          setVerificationData({
            name: result.name,
            date: result.date,
            id: result.certificateId,
          });
          setError("");
          toast.success("Certificate verified successfully!"); 
        } else {
          setError("Invalid Certificate ID");
          setVerificationData(null);
          toast.error("Invalid Certificate ID");
        }
      } catch (err) {
        setError("Faild to verify");
        setVerificationData(null);
        toast.error("Failed to verify"); 
      } finally {
        setLoading(false); 
      }

      setCertificateId("");
    }
  };

  const validateForm = () => {
    if (!certificateId.trim()) {
      setError("Certificate ID is required.");
      setVerificationData(null);
      return false;
    }
    if (!/^[a-zA-Z0-9-]+$/.test(certificateId)) {
      setError("Certificate ID must only contain letters, numbers, and hyphens.");
      setVerificationData(null);
      return false;
    }
    setError("");
    return true;
  };

  return (
    <div className="verification-container">
      <Toaster /> 
      <div className="verification-card">
        <div className="text-center header">
          <h3>Verify Certificate</h3>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="input-container">
            <input
              type="text"
              id="certificate-id"
              value={certificateId}
              onChange={(e) => setCertificateId(e.target.value)}
              placeholder="Enter certificate ID"
            />
            {error && <p className="error-message">{error}</p>}
          </div>
          <button type="submit" className="verify-button" disabled={loading}>
            {loading ? "Loading..." : "Verify"}
          </button>
        </form>
        {verificationData && (
          <div className="verification-success">
            <h4>Certificate Verified Successfully!</h4>
            <p><strong>Name:</strong> {verificationData.name}</p>
            <p><strong>Date:</strong> {verificationData.date}</p>
            <p><strong>Certificate ID:</strong> {verificationData.id}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CertificateVerification;
